export default "__VITE_ASSET__DOfHrZIG__"